import { autoinject } from "aurelia-framework";

import { FetchClient } from "../common/fetch-client";
import config from "../common/config";
import type {
    IDeleteMeetingRequest,
    ISuccessRoomId,
    IEditMeetingRequest,
    IForwardMeetingRequest,
    IGetScheduledMeetingsQuery,
    IGetScheduledMeetingsResponse,
    IInviteMeetingRequest,
    ICommonApiResponse,
    IMeetingConflicResponse,
    IMeetingConflictRequest,
    IRemoveMeetingRequest,
    IRemoveMeetingResponse,
    IScheduleMeetingRequest,
    IScheduleMeetingResponse,
    IJoinCalendarMeetingRes
} from "../resources-vue/vue-interfaces/messaging-service/i-meeting-calendar";

@autoinject()
export class MeetingCalendarService {
    private _httpClient: FetchClient;
    private _baseMessagingUrl: string = `${config.messagingServiceServerURL}/api/v1`;
    private queryHeaders = {
        "X-Chat-AgencyId": "122ec20a-705b-4974-9437-8f6233a6e953",
        DeviceType: "Web"
    };

    public constructor(httpClient: FetchClient) {
        this._httpClient = httpClient;
    }

    public async getScheduledMeetings(query: IGetScheduledMeetingsQuery) {
        return await this._httpClient
            .build(`${this._baseMessagingUrl}/meeting/scheduled`)
            .useMode("cors")
            .useQueryString(query)
            .useHeaders(this.queryHeaders)
            .fetch<IGetScheduledMeetingsResponse>();
    }

    public async scheduleMeeting(payload: IScheduleMeetingRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingUrl}/meeting/schedule`)
            .useMode("cors")
            .useHeaders(this.queryHeaders)
            .useMethod("POST")
            .useBody(payload)
            .fetch<IScheduleMeetingResponse>();
    }

    public async editMeeting(payload: IEditMeetingRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingUrl}/meeting/edit`)
            .useMode("cors")
            .useHeaders(this.queryHeaders)
            .useMethod("POST")
            .useBody(payload)
            .fetch<ISuccessRoomId>();
    }

    public async deleteMeeting(payload: IDeleteMeetingRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingUrl}/meeting/delete`)
            .useMode("cors")
            .useHeaders(this.queryHeaders)
            .useMethod("POST")
            .useBody(payload)
            .fetch<ISuccessRoomId>();
    }

    public async inviteMeeting(payload: IInviteMeetingRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingUrl}/meeting/invite`)
            .useMode("cors")
            .useHeaders(this.queryHeaders)
            .useMethod("POST")
            .useBody(payload)
            .fetch<ICommonApiResponse>();
    }

    public async forwardMeeting(payload: IForwardMeetingRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingUrl}/meeting/forward`)
            .useMode("cors")
            .useHeaders(this.queryHeaders)
            .useMethod("POST")
            .useBody(payload)
            .fetch<ICommonApiResponse>();
    }

    public async removeMeeting(payload: IRemoveMeetingRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingUrl}/meeting/remove`)
            .useMode("cors")
            .useHeaders(this.queryHeaders)
            .useMethod("POST")
            .useBody(payload)
            .fetch<IRemoveMeetingResponse>();
    }

    public async checkConflict(payload: IMeetingConflictRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingUrl}/meeting/check-conflict`)
            .useMode("cors")
            .useHeaders(this.queryHeaders)
            .useMethod("POST")
            .useBody(payload)
            .fetch<IMeetingConflicResponse>();
    }

    public async joinCalendarMeeting(meetingId: string) {
        return await this._httpClient
            .build(`${this._baseMessagingUrl}/meeting/join`)
            .useMode("cors")
            .useHeaders(this.queryHeaders)
            .useMethod("POST")
            .useBody({ meetingId })
            .fetch<IJoinCalendarMeetingRes>();
    }
}
